<template>
  <b-modal id="add-or-update" :visible="isAddOrUpdateActive" centered hide-footer hide-header no-close-on-esc
    no-close-on-backdrop @hidden="resetForm" @hide="resetForm"
    @change="(val) => $emit('update:is-add-or-update-active', val)">
    <template #default="{ hide }">
      <b-overlay :show="loading" class="px-2">
        <div class="d-flex justify-content-between align-items-center content-sidebar-header py-1"
          style="border-bottom: 1px solid #000000">
          <h5 class="mb-0" style="font-weight: 400; font-size: 14px; line-height: 160%">
            {{ isUpdate ? "Update Church Map" : "Add New Church Map" }}
          </h5>

          <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
        </div>

        <validation-observer #default="{ handleSubmit }" ref="update_modal_form">
          <b-form class="my-1" @submit.prevent="handleSubmit(onCreateOrUpdate)" @reset.prevent="resetForm">

            <b-alert v-if="errorMessage" variant="danger" :show="true">
              <div class="alert-body font-small-2">
                <b-card-text class="mb-0">
                  {{ errorMessage }}
                </b-card-text>
              </div>
            </b-alert>

            <!-- region -->
            <b-form-group label="Region" label-for="region">
              <template #label>
                <span>Region<span style="color: tomato">*</span></span>
              </template>

              <validation-provider #default="{ errors }" name="region" rules="required">
                <v-select id="region" v-model="new_data.region_id" :loading="loading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="regionOptions"
                  :reduce="(val) => val.value" :clearable="false" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- area -->

            <b-form-group label="Area" label-for="area">
              <template #label>
                <span>Area<span style="color: tomato">*</span></span>
              </template>

              <validation-provider #default="{ errors }" name="area" rules="required">
                <v-select id="area" v-model="new_data.area_id" :loading="loading" :clearable="false"
                  :options="areaOptions" :reduce="(val) => val.value"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- district -->
            <b-form-group label="District" label-for="district">
              <template #label>
                <span>District<span style="color: tomato">*</span></span>
              </template>

              <validation-provider #default="{ errors }" name="district" rules="required">
                <v-select id="district" v-model="new_data.district_id" :loading="loading" :clearable="false"
                  :options="districtOptions" :reduce="(val) => val.value"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>


            <!-- assembly -->

            <b-form-group label="Assembly" label-for="assembly">
              <template #label>
                <span>Assembly<span style="color: tomato">*</span></span>
              </template>

              <validation-provider #default="{ errors }" name="assembly" rules="required">
                <v-select id="assembly" v-model="new_data.assembly_id" :loading="loading" :clearable="false"
                  :options="assemblyOptions" :reduce="(val) => val.value"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- assembly type -->

            <b-form-group label="Assembly-type" label-for="assembly-type">
              <template #label>
                <span>Assembly Type</span>
              </template>

              <validation-provider #default="{ errors }" name="assembly_type" rules="">
                <v-select id="assembly_type" v-model="new_data.assembly_type" :loading="loading" :clearable="false"
                  :options="assemblyTypeOptions" :reduce="(val) => val.value"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Latitude -->

            <validation-provider #default="validationContext" name="Latitude" rules="">
              <b-form-group label="Latitude" label-for="latitude">
                <template #label>
                  <span>Latitude</span>
                </template>

                <b-form-input id="latitude" v-model="new_data.latitude" placeholder="" :disabled="disableForm"
                  :state="getValidationState(validationContext)" />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!--Longitude -->

            <validation-provider #default="validationContext" name="Longitude" rules="">
              <b-form-group label="Longitude" label-for="longitude">
                <template #label>
                  <span>Longitude</span>
                </template>

                <b-form-input id="longitude" v-model="new_data.longitude" placeholder="" :disabled="disableForm"
                  :state="getValidationState(validationContext)" />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit"
                :disabled="disableForm">
                {{ isUpdate ? "Update" : "Add" }}
              </b-button>

              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" variant="outline-secondary"
                @click="hide">
                Cancel
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-overlay>
    </template>
  </b-modal>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BAlert,
  BButton,
  BCardText,
  BCol,
  BForm,
  BFormCheckbox,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormTextarea,
  BImg,
  BMedia,
  BMediaAside,
  BMediaBody,
  BModal,
  BOverlay,
  BRow,
  BSidebar,
} from "bootstrap-vue";


import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { get, cloneDeep, omit } from 'lodash';

import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import generalMixin from '@core/mixins/general'

const rawChurchMapData = {
  region_id: "",
  district_id: "",
  area_id: "",
  assembly_id: "",
  assembly_type: "",
  latitude: 0,
  longitude: 0,
};

export default {
  components: {
    BImg,
    BForm,
    BAlert,
    BModal,
    BMedia,
    BButton,
    vSelect,
    BOverlay,
    BSidebar,
    BCardText,
    BFormFile,
    BFormGroup,
    BMediaBody,
    BFormInput,
    BMediaAside,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormCheckbox,
    BRow,
    BCol,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [generalMixin],
  model: {
    prop: 'isAddOrUpdateActive',
    event: 'update:is-add-or-update-active',
  },
  props: {
    isAddOrUpdateActive: {
      type: Boolean,
      required: true,
    },
    updateData: {
      type: Object,
      default: null,
      required: false
    },
  },
  data() {
    return {
      new_data: cloneDeep(rawChurchMapData),
      loading: false,
      errorMessage: "",


      regionOptions: [],
      areaOptions: [],
      districtOptions: [],
      assemblyOptions: [],
      assemblyTypeOptions: [],

      required,
    }
  },
  computed: {
    isUpdate() {
      return !!this.updateData
    },
    disableForm() {
      if (this.isUpdate) {
        return !this.can("church_map:CanUpdate")
      }

      return !this.can("church_map:CanAddNew")
    },
  },
  watch: {
    updateData: {
      handler(updateData) {
        if (updateData) {
          this.new_data = {
            _id: updateData._id,
            region_id: updateData.region_id,
            district_id: updateData.district_id,
            area_id: updateData.area_id,
            assembly_id: updateData.assembly_id,
            assembly_type: updateData.assembly_type,
            latitude: updateData.latitude || 0,
            longitude: updateData.longitude || 0,
          };
        }
      },
      immediate: true,
      deep: true,
    },
    "new_data.region_id": {
      handler(changed) {
        if (changed) {
          this.fetchChurchAreas();
        }
      },
      immediate: true,
    },
    "new_data.area_id": {
      handler(changed) {
        if (changed) {
          this.fetchChurchDistrict();
        }
      },
      immediate: true,
    },
    "new_data.district_id": {
      handler(changed) {
        if (changed) {
          this.fetchChurchAssemblies();
        }
      },
      immediate: true,
    },
    "new_data.assembly_id": {
      handler(changed) {
        if (changed) {
          this.fetchChurchAssemblyTypes();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.fetchChurchRegions();
  },
  methods: {
    async onCreateOrUpdate() {
      try {
        this.loading = true;
        this.errorMessage = "";

        const success = await this.$refs.update_modal_form.validate();
        if (!success) {
          return;
        }

        const messages = {
          update: {
            title: "Confirm church map Update",
            text: "You are about to update details of a church map.",
            icon: "warning"
          },
          new: {
            title: "Create church map",
            text: "You are about to create a church map",
            icon: "info"
          }
        }

        /* eslint-disable no-nested-ternary */
        const message = this.isUpdate ? messages.update : messages.new;
        const { title, text, icon } = message;

        const result = await this.$swal({
          title,
          text,
          icon,
          showCancelButton: true,
          confirmButtonText: 'Yes, proceed.',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });
        if (!result.isConfirmed) {
          return;
        }

        if (this.isUpdate) {
          const id = this.new_data._id;
          const update_data = omit(this.new_data, "_id");

          if (!this.can("church_map:CanUpdate")) {
            return;
          }
          await this.useJwt().mainService.churchMap.update(id, update_data);
        } else {
          if (!this.can("church_map:CanAddNew")) {
            return;
          }

          await this.useJwt().mainService.churchMap.create(this.new_data);
        }
        this.$emit("refetchData");
        this.$emit("update:is-add-or-update-active", false);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'AlertQuestionIcon',
            variant: 'success',
            text: `Church Map ${this.isUpdate ? 'updated' : 'added'} successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message;
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    async fetchChurchRegions() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoRegions();
        const { data } = request.data;
        this.regionOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAreas() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoAreas(
          { region_id: this.new_data.region_id }
        );
        const { data } = request.data;
        this.areaOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchDistrict() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoDistricts(
          { area_id: this.new_data.area_id }
        );
        const { data } = request.data;
        this.districtOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAssemblies() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoAssemblies(
          { district_id: this.new_data.district_id }
        );
        const { data } = request.data;
        this.assemblyOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAssemblyTypes() {
      try {
        this.loading = true;

        await this.useJwt().mainService.churchMap.fetchAssemblyTypes();

        const types = [
          'Central Assembly',
          'Church Land',
          'Local Assembly',
          'Mission House',
          'Farm',
          'Land',
          'Area Office',
          'District Office',
          'RCC Office',
          'Office',
          'Headquarters',
          'Prayer Centre',
          'School',
          'Worship Centre',
          'PIWC',
          'Other'
        ];

        // const { data } = request.data;
        // console.log(data);

        this.assemblyTypeOptions = types.map((opt) => ({
          label: opt,
          value: opt,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.$emit("resetUpdateData");
      this.new_data = {};
      if (this.$refs.update_modal_form) {
        this.$refs.update_modal_form.reset()
      }
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-or-update {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
